import fetch from 'isomorphic-fetch';
import { clientLogger } from '../lib/logger';
import { FAVORITES_API_URL } from '../lib/constants';

export const updateFavorites = (favorites = {}) => {
  // sys object gets attached on empty response from RPS
  // not sure why, remove to keep state clean
  if (favorites.sys) {
    delete favorites.sys;
  }

  return {
    type: 'UPDATE_RPS_FAVORITES',
    favorites
  };
};

export const getRPSFavorites = (params, query, headers) => {
  return dispatch => {
    let url = FAVORITES_API_URL;

    if (headers.merchantHubHost) {
      url = `${headers.merchantHubHost}${url}`;
    }

    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers
    })
      .then(res => (res.ok ? res.json() : {}))
      .then(faves => {
        dispatch(updateFavorites(faves));
      })
      .catch(err => {
        clientLogger.warn('Failed to get favorites from RPS', err);
        dispatch(updateFavorites({}));
      });
  };
};

const revertFavorites = (dispatch, getState, toolKey) => {
  const {
    appcenter: { favorites = {} }
  } = getState();
  const newFavorites = { ...favorites };
  //eslint-disable-next-line
  newFavorites[toolKey]
    ? delete newFavorites[toolKey]
    : (newFavorites[toolKey] = 1);
  dispatch(updateFavorites(newFavorites));
};

export const setRPSFavorites = toolKey => {
  return (dispatch, getState) => {
    const {
      appcenter: { favorites = {} } = {},
      app: { csrf = '' } = {}
    } = getState();
    const url = FAVORITES_API_URL;
    const newFavorites = { ...favorites };

    //eslint-disable-next-line
    newFavorites[toolKey]
      ? delete newFavorites[toolKey]
      : (newFavorites[toolKey] = 1);

    // need this in case user favorites/unfavorites many things quickly
    dispatch(updateFavorites(newFavorites));

    return fetch(url, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf
      },
      body: JSON.stringify(newFavorites)
    })
      .then(res => res.json())
      .then(({ err }) => {
        if (err) {
          clientLogger.warn('Error updating tools, check RPS server logs', {});
          revertFavorites(dispatch, getState, toolKey);
        }
      })
      .catch(err => {
        clientLogger.warn('Error updating tools', err);
        revertFavorites(dispatch, getState, toolKey);
      });
  };
};

export const updateSearchQuery = query => ({
  type: 'UPDATE_SEARCH_QUERY',
  query
});

export const updateSearchResults = results => ({
  type: 'UPDATE_SEARCH_RESULTS',
  results
});

export const clearSearch = () => ({
  type: 'CLEAR_SEARCH'
});

export const setSearchActive = value => ({
  type: 'SET_SEARCH_ACTIVE',
  value
});
